module.exports = {
          srcSet: __webpack_public_path__ + "public/images/73e0d061b27a1e39e226b5419fc4ff7a-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/73e0d061b27a1e39e226b5419fc4ff7a-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/73e0d061b27a1e39e226b5419fc4ff7a-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/73e0d061b27a1e39e226b5419fc4ff7a-1774.jpg"},
          
          width: 1774,
          height: 887
        }